/* eslint-disable no-nested-ternary */
import format from "date-fns/format";
import { keyBy } from "lodash/fp";
import {
  ALL_DATES,
  INTEGER_KEYS,
  AppliedFilterLabelMap,
  DATES,
  DROPDOWN_KEYS,
  DROPDOWN_REDUX_KEY_MAPPER,
  EXCLUDE_DATES,
  OS_DROPDOWN_KEYS,
} from "../../../contants";
import { ROUTES } from "../../../utils/constants";
import { isEmptyObj, isOSKey } from "../../../utils/helper";

const DATE_FORMAT = "yyyy-MM-dd";
const PLUS = "plus";
// const OS_LABEL = "organisationStructure";
export const POSITIONS_KEY = "positions";
export const MAINLINE_POSITION_KEY = "mainlinePositions";
export const NO_OF_MONTHS = "numberOfMonths";

export const performOperation = (value, limit, operator = PLUS) =>
  operator === PLUS ? Number(value) + limit : Number(value) - limit;

export const getRoutePath = () => ROUTES.REPORTS_SUBSCRIPTION.path;
export const getExpiredSubscriptionRoutePath = () =>
  ROUTES.REPORTS_EXPIRED_SUBSCRIPTION.path;

export const getNearToExpirySubscriptionRoutePath = () =>
  ROUTES.REPORTS_NEAR_TO_EXPIRY_SUBSCRIPTION.path;

export const getRoutePathSubscriptionTrends = () =>
  ROUTES.REPORTS_SUBSCRIPTION_TRENDS.path;

export const getRoutePathSubscriptionMis = () =>
  ROUTES.REPORTS_SUBSCRIPTION_MIS.path;

const handlePositions = (queryObject, currObj, key) => {
  const currentPositions = currObj[POSITIONS_KEY] ?? [];

  const keyValue = queryObject[key]
    ? queryObject[key].split(",").map(Number)
    : [];

  return [...currentPositions, ...keyValue];
};

const handleOS = (queryObject, currObj, key) => {
  // const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    // [OS_LABEL]: { ...currentOS,
    [key]: Number(queryObject[key]),
  });
};

export const getFormattedQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];
        // console.log(value);
        const key = currKey === MAINLINE_POSITION_KEY ? POSITIONS_KEY : currKey;

        if (INTEGER_KEYS.includes(currKey)) {
          value = Number(queryObject[currKey]);
        } else if (ALL_DATES.includes(currKey)) {
          value = format(new Date(queryObject[currKey]), DATE_FORMAT);
        } else if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(currKey)) {
          value = handlePositions(queryObject, acc, currKey);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        }
        return Object.assign(acc, {
          [key]: value,
        });
      }, {})
    : {};

export const getFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        const fromDate = queryObject[curr];
        const toDate = queryObject[`${key}To`];
        const value = toDate ? `${fromDate} - ${toDate}` : fromDate;

        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[key],
          value,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if (curr === "startDate") {
        // const key = curr;
        const value = queryObject[curr];
        acc.push({
          key: curr,
          displayName: "Date From",
          value,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if (curr === "endDate") {
        // const key = curr;
        const value = queryObject[curr];
        acc.push({
          key: curr,
          displayName: "Date To",
          value,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      // if (DATES.includes(curr)) {
      //   const key = curr.split("From")[0];
      //   acc.push({
      //     key: curr,
      //     displayName: AppliedFilterLabelMap[key],
      //     value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
      //     disabled: disabledOSKeys.includes(curr),
      //   });
      //   return acc;
      // }
      if (curr === NO_OF_MONTHS) {
        acc.push({
          key: curr,
          displayName: "Number of Months",
          value: queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }
      // handle dropdowns
      if (DROPDOWN_KEYS.includes(curr) || OS_DROPDOWN_KEYS.includes(curr)) {
        const pool = isOSKey(curr)
          ? metaData.organisationStructure[DROPDOWN_REDUX_KEY_MAPPER[curr]]
          : metaData[DROPDOWN_REDUX_KEY_MAPPER[curr]];

        const selectedValue = pool.find(
          (p) =>
            (p.structureId || p.divisionId || p.cityId || p.stateId) ===
            Number(queryObject[curr])
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[curr],
          value:
            selectedValue?.name ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.positions);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[curr],
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      // rest
      // rest
      acc.push({
        key: curr,
        displayName: AppliedFilterLabelMap[curr],
        value:
          curr === "type" && queryObject[curr] === "FDT"
            ? "SS"
            : queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });

      return acc;
    }
    return acc;
  }, []);

export const handleDependencyFilter = (query) => {
  const updatedQueryWithOS = { ...query };
  if (!updatedQueryWithOS?.areaId) {
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.zoneId) {
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.regionId) {
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.chapterId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.districtId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  }

  // state and divisions
  if (!updatedQueryWithOS?.state) {
    delete updatedQueryWithOS.city;
  }
  if (!updatedQueryWithOS?.divisionId) {
    delete updatedQueryWithOS.subdivisionId;
  }

  return updatedQueryWithOS;
};
